import { AdminPanelHeadingText } from '../admin-panel-heading-text';
import styled from 'styled-components';

export const AdminPanelHeading = styled.div`
  display: flex;
  user-select: none;

  * + & {
    margin-top: 1.5rem;
  }

  ${AdminPanelHeadingText} {
    flex: 1;
  }
`;
